import { Quickbooks } from './types';

export const transformQuickbooks = (res: any): Quickbooks => {
  return {
    accountType: res.accountType,
    accountingId: res.accountingId,
    accountingName: res.accountingName,
  };
};
